import React,{Fragment,useState} from 'react';
import styled from "styled-components";
import clienteAxios from '../config/axios';
import Swal from 'sweetalert2';




const Contacto = () => {

const [mensajeCliente,guardarMensaje] = useState({
    nombre:"",
    email:"",
    asunto:"",
    mensaje:""
});


// Guarda datos al escribir en el input
const handleChange = (e) =>{

    guardarMensaje({
    ...mensajeCliente,
    [e.target.name] : e.target.value
    });

}

// Al hacer submit

const handleSubmit =  e =>{
    e.preventDefault();



    const {nombre,email,asunto,mensaje} = mensajeCliente;


   if(!nombre.trim()||!email.trim()||!asunto.trim()||!mensaje.trim()){

    Swal.fire(
        'Datos incompletos!',
        'Favor de llenar todos los campos!',
        'error',
        
      )
      return;
   }

  
       clienteAxios.post("/mensajes",mensajeCliente)
        .then(res=>{
            if(res.data.code === 11000){
            
                Swal.fire(
                    'Ups!',
                    'Hubo algun error!',
                    'error'
                  )
                  
             
            }else{
                Swal.fire(
                    'Mensaje enviando!',
                    'Gracias por contactarnos, te responderemos a la brevedad!',
                    'success'
                  )
                
            }
        })



  
    
   

   
}



    return (
<Fragment>
    <H3>Contacto</H3>
    <Div>

        <DivText>
            <h4>Obten tu cotizacion GRATIS</h4>
            <p>Creamos estrategias en redes sociales orientadas a generar ventas, con campañas especificas hacia tu publico objetivo.</p>
            <p>Solicita mas informacion e <span>Impulsa</span> tu negocio hacia el futuro DIGITAL.</p>
        </DivText>
        

    <Form
    onSubmit={handleSubmit}
    >
    <div>
     <label htmlFor="nombre">Nombre :</label>
     <input 
     type="text" 
     id="nombre" 
     placeholder="Nombre"
     name="nombre"
     onChange={handleChange} 
     /> 
     </div>

     <div>
     <label htmlFor="email">Email :</label>
     <input 
     type="mail" 
     id="email" 
     placeholder="Correo electronico" 
     name="email"
     onChange={handleChange} 
     /> 
     </div>

     <div>
     <label htmlFor="asunto">Asunto :</label>
     <input 
     type="text" 
     id="asunto" 
     placeholder="Asunto de tu mensaje" 
     name="asunto"
     onChange={handleChange} 
     /> 
     </div>

     <div>
     <label htmlFor="mensaje">Mensaje :</label>
     <textarea 
     name="mensaje" 
     id="mensaje" 
     cols="30" 
     rows="10"
     onChange={handleChange} 
     >
     </textarea>
     </div>

     <button type="submit">Enviar</button>


    </Form>
    </Div>
</Fragment>


      );
}



 
export default Contacto;





const H3 = styled.h3`
text-transform: uppercase;
letter-spacing: 0.5em;
    text-align: center;
    margin: 20px auto;
    color: #7B7554;
    font-size: 1.5em;

`


const Form = styled.form`

width: 65%;
margin: 25px;
background-color: #E63946;
padding: 20px;
border-radius: 10px;

div{
    width: 80%;
    margin: 15px auto;
    label{
        display: inline-block;
        letter-spacing: 0.20em;
         margin: 5px 0;
        color: #FFF

    }
    input,textarea{
       
        outline: none;
        width: 100%;
        padding: 10px;
        border-radius: 8px;
        border: none;
       letter-spacing: 0.20em;
    }



    @media(max-width:668px){
        display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    }
}



button{
    padding: 10px 20px;
    border: none;
    border-radius: 10px;
    display: block;
    margin-left: auto;
    margin-right: 30px;
    background-color: #7433EF;
    color: rgba(255, 255, 255, 0.903);
    text-transform: uppercase;
    letter-spacing: 0.10em;
    font-weight: 800;
    cursor: pointer;


    :hover{
        background-color: #8547f8;
        color: rgba(255, 255, 255, 0.753);
    }

  
}




@media(max-width:668px){
margin: 25px auto;

}



`




const Div= styled.div`

display: flex;




@media(max-width:668px){
flex-direction: column-reverse;
}
`


const DivText = styled.div`

padding: 20px;
margin-top: 60px;
h4{
    text-transform: uppercase;
    letter-spacing: 0.1em;
    text-align: center;
    color: #E63946;
}


p{
    margin-left: 10px;
    letter-spacing: 0.01em;
    span{
        color: #E63946;
        font-size: large;
        text-transform: uppercase;
        letter-spacing: 0.08em;
    }
    @media(max-width:668px){
        text-align: center;
}
}







`
